import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=baa25716&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=baa25716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa25716",
  null
  
)

export default component.exports